import React from 'react';
import classNames from 'classnames';
import CSSModules from 'react-css-modules';
import config from 'config';
import styles from './DonateButton.scss';
import { Trans } from 'react-i18next';
import { useDonatePopup } from 'src/components/DonatePopup/DonatePopupContext';
import getRandom from 'src/helpers/random';

interface Props {
  isActive: boolean;
  name: string;
  pageSection: string;
  donate: (options: { pageSection: string }) => void;
  id: string;
}

export function DonateButton({
  isActive,
  name,
  pageSection,
  donate,
  id,
}: Props) {
  const { showCheckoutPopup } = useDonatePopup();
  const buttonClass = classNames('jg-btn', {
    'is-disabled': !isActive,
  });

  const buildQueryString = (showEmbeddedCheckout?: boolean) => {
    const urlParams = new URLSearchParams();

    if (pageSection) {
      urlParams.append('pageSection', pageSection);
    }

    if (showEmbeddedCheckout) {
      urlParams.append('checkoutMode', 'Headless');
    }

    return urlParams.toString() ? `?${urlParams.toString()}` : '';
  };

  const useLinkService =
    getRandom() <= config.PERCENTAGE_OF_DONATIONS_TO_START_IN_LINK_SERVICE;
  let donateLink: string;

  if (isActive) {
    donateLink = useLinkService
      ? `${
          config.LINK_SERVICE_BASE_URI
        }/v1/crowdfundingpage/donate/pageid/${id}?startedBy=cfwebsite`
      : `${config.CROWDFUNDING_BASE_URI}/${name}/donate${buildQueryString()}`;
  }

  const onClickDonate = (event: React.MouseEvent<HTMLAnchorElement>) => {
    const urlParams = new URLSearchParams(window.location.search);
    if (
      config.FEATURE.EMBEDDED_CHECKOUT ||
      urlParams.get('popupCheckout') === 'true'
    ) {
      event.preventDefault();
      const modalDonateLink = useLinkService
        ? `${donateLink}&checkoutMode=Headless`
        : `${config.CROWDFUNDING_BASE_URI}/${name}/donate${buildQueryString(
            true
          )}`;
      showCheckoutPopup(modalDonateLink);
    }
    donate({ pageSection });
  };

  return (
    <a
      data-marker="donate-button"
      onClick={onClickDonate}
      href={donateLink}
      className={buttonClass}
      styleName="fixed-donate-button"
    >
      <Trans i18nKey="Common.Donate">Give Now</Trans>
    </a>
  );
}

export default CSSModules(DonateButton, styles);



// WEBPACK FOOTER //
// ./src/components/Page/DonateButton.tsx